const data = [
  {
      "key": "Platform",
      "value": "Mac, Windows."
  },
  {
      "key": "Application Development",
      "value": "Applications iOS, iPadOS, macOS Catalyst"
  },
  {
      "key": "Architectures & Design Patterns",
      "value": "MVC, MV-VM, Singleton, VIPER, Clean Architecture, Microservice architecture, Componentization using pods & carthage"
  },
  {
      "key": "Languages",
      "value": "Swift, Objective C, Kotlin, NodeJS, ReactJS"
  },
  {
      "key": "APIs / Libraries",
      "value": "Firebase, Instabug, Crashlytics, Google Maps, Facebook, Twitter, AdMobs, Google Sign in, DropBox"
  },
  {
      "key": "DevOps",
      "value": "Fastlane, Githooks HockeyApp, Jenkins, SemaphoreCI"
  },
  {
      "key": "Project Management Tools",
      "value": "Atlassian, RedMine, Basecamp, Assembla, Rally"
  },
  {
      "key": "Bug Tracking Tools",
      "value": "Mantis Bug-tracker, Jira"
  },
  {
      "key": "Prototype/Mockup Tools",
      "value": "Balsamiq, NinjaMock, iPlotz, OmniGraffel"
  },
  {
      "key": "Quick Image Editing Tools",
      "value": "Preview, Seashore, Paintbrush"
  },
  {
      "key": "iOS Frameworks",
      "value": "UIKit, MapKit, CoreLocation, MediaPlayer, Addressbook, CoreData, MessageUI, Authentication"
  },
  {
      "key": "Web languages",
      "value": "XML, JSON, HTML, CSS"
  },
  {
      "key": "Databases",
      "value": "SQLite, MySQL"
  },
  {
      "key": "Tools",
      "value": " Xcode, zsh, SourceTree"
  },
  {
      "key": "Subversions",
      "value": "SVN, Git, HG Mercurial"
  },
  {
      "key": "App Store & AdHoc",
      "value": "Developer & Distribution Certificates management, Keychain access, App Identifiers, Passbook identifiers, APNS, iTunesConnect, App Versions, Device management, Crash logs"
  },
  {
      "key": "API/WebService Analysis",
      "value": "SOAP UI, Postman in Chrome, RestClient in Firefox, SOAP Client for Mac"
  }
];

export default data;